import { useAtom } from 'jotai';
import { atomWithLocalStorage } from 'src/utils/atomWithLocalStorage';

const hasClickedBiennialOfferStore = atomWithLocalStorage<boolean>(
  'rm.hasClickedBiennialOffer',
  false
);

export const useHasClickedBiennialOffer = () =>
  useAtom(hasClickedBiennialOfferStore);
